import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';
import { ExportFormatterUtil } from './export-formatter.util';

export class InvoiceExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getHeaders(): string[] {
    return [
      'Claim Number',
      'Claimant Name',
      'Contract Number',
      'Contract Name',
      'Bill Status',
      'Internal Control Number',
      'Treating Provider',
      'JURIS Received Date',
      'Billed Amount',
      'Payee Name',
      'Vendor Name',
      'Sedgwick Received Date',
      'Service Begin Date',
      'Service End Date',
      'Recommended Allowance',
      'Provider Paid',
      'DCN',
      'SIR DCN',
      'Bill Category',
    ];
  }

  private static mapRowsToExportData(rows: any[]): any[][] {
    return rows.map((row) => [
      row.claimNumber || '',
      row.claimantName || '',
      row.contractNumber || '',
      row.contractName || '',
      row.billStatus || '',
      row.icn || row.Icn || '',
      row.treatingProvider || '',
      ExportFormatterUtil.formatDate(row.rcvdJuris),
      ExportFormatterUtil.formatCurrency(row.billedAmount),
      row.payee && row.payee !== 'N/A' ? row.payee : '',
      row.vendorName || '',
      ExportFormatterUtil.formatDate(row.rcvdSedgwick),
      ExportFormatterUtil.formatDate(row.dosBegin),
      ExportFormatterUtil.formatDate(row.dosEnd),
      ExportFormatterUtil.formatCurrency(row.recAmount),
      ExportFormatterUtil.formatDate(row.providerPaid),
      row.dcn || '',
      row.sirDcn || '',
      row.billCategory || '',
    ]);
  }
}
